import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { List, Dialog } from 'antd-mobile'

import './index.less';

const PageModel = props => {
	const [list, setList] = useState([]);

	const getList = async () => {
		const result = await Request.get({
			url: '/company/list'
		});
		if (!result) return;

		const list = result.data.list || [];
		setList(list);
	};
	
	useEffect(() => {
		//获取企业列表
		getList()
	}, [123]);

	const postdata = (item) => {
		console.log('公司id',item.id);
		Dialog.confirm({
			content: '确定删除'+item.companyName+'吗？',
			onConfirm: async () => {
				Request.post({
					url: '/company/delete',
					data: {	
						id: item.id,
					}	
				}).then(res => {
					console.log(res);
					if (res.ok === 0) {
						getList();
					}
				}).catch(err => {
					console.log(err);
				});
			},
		})
	}

	return (
		<List>
			
			{list.length > 0 && list.map((item, index) => {
				return (
					// <List.Item disabled={item.equipmentlist.length > 0} extra={item.equipmentlist.length > 0? '已绑定设备' : ''} key={index} onClick={() => {	
					// 	postdata(item)
					// }}>{item.companyName}</List.Item>
					<div className='list-item' key={index}>
						<div className='list-item-content'>
							<div className='list-item-title'>{item.companyName}</div>
							<div className='list-item-name'>{item.enterpriseName}</div>
						</div>
						<div className='list-item-extra'>
							<div className='list-item-extra-btn' onClick={() => {
								console.log(item.id);
								props.history.push('/company/' + item.id)
							}}>
								<EditOutlined />
							</div>
							<div className='list-item-extra-btn' onClick={() => {
								postdata(item)
							}}>
								<DeleteOutlined />
							</div>
						</div>
					</div>
				)
				})
			}

			<div className='list-add-btn' onClick={() => props.history.push('/company/0')}>新增企业</div>
		</List>
	);
};

export default PageModel;
